// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1rgwS","label":"Completed_label__Dtc1_"};